/* Component Dependencies */
var guestRoomInformationTemplate = require('templates/guestRoomInformation.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'guestRoomInformation',
  template: {
    'guestRoomInformation': guestRoomInformationTemplate
  }
});
